import styled from 'styled-components';
import { MenuList } from '@groupby/ui-components';
export const StyledMenuList = styled(MenuList) `
  && {
    li.MuiMenuItem-root span {
      font-size: 0.875rem;
    }
  }
`;
